export class EmailRecipient {
  email: string;
  name: string;
  profileId: number;
  sendOnBehalf: boolean = false;
}
